import React from 'react';
import Page from '../Page';
import '../../styles/gameQuiz.css';

class WordMatchingGame extends Page {
  constructor(props) {
    super(props);
    const first_states = this.beforeRender(props);
    this.state = {
      draggedWord: null,
      isMatched: false,
      choicesCopy: [],
      dropWords: {},
      submitted: false,
      ...first_states,
    };
  }

  beforeRender() {
   return {
      choices: this.props.answer,
      quiz: this.props.question,
    }
  }

  componentDidMount() {
    this.setState({ choicesCopy: [...this.state.choices] });
  }

  handleDragOver = (e) => {
    e.preventDefault();
  }

handleDragStart = (e, word) => {
    e.dataTransfer.setData('text/plain', word);
    this.setState({ draggedWord: word });
  }

  handleDrop = (quiz, e) => {
   e.preventDefault();
   const droppedWord = e.dataTransfer.getData('text/plain');
 
   // Remove the dropped answer from choices
   const newChoices = this.state.choices.filter(choice => choice.name !== droppedWord);
   this.setState({ choices: newChoices });
 
   this.setState({ dropWords: { ...this.state.dropWords, [quiz.id]: droppedWord } });
 
   const quiz_index = this.state.quiz.findIndex(item => item === quiz);
   const answer_index = this.state.choicesCopy.findIndex(item => item.name === droppedWord);
 
   if (answer_index !== -1) {
     const newQuiz = [...this.state.quiz];
     if (this.state.choicesCopy[answer_index].id === quiz.answer_id) {
       newQuiz[quiz_index].isMatched = true;
       newQuiz[quiz_index].isAnswered = true;
     } else {
       newQuiz[quiz_index].isAnswered = true;
       setTimeout(() => {
         this.resetPosition();
       }, 300);
     }
     this.setState({ quiz: newQuiz });
   }
 }
 
 

  handleAnswerChoices = (quiz) => {
   return this.state.dropWords && this.state.dropWords.hasOwnProperty(quiz.id) ? this.state.dropWords[quiz.id] : '';
 }
 

  resetPosition = () => {
    this.setState({ position: this.initialPosition });
  }

  handleSubmission = () => {
    // Perform any additional validation or processing before showing the result
    this.setState({ submitted: true });
  };

  render() {
   const answerBoxStyle = this.state.isAnswered ? { ...this.state.position, position: 'absolute' } : {};
   return (
      <div style={{position:'relative'}}>
         <div className="match-word">
            <div className="question-side">
               {this.state.quiz.map((quiz, index) => {
               return (
                  <div className="question-list" key={index}>
                     <p className="question">{quiz.question}</p>
                     <div
                     className={`drop-zone ${quiz.isAnswered ? 'choice' : ''}`}
                     onDragOver={this.handleDragOver}
                     onDrop={(e) => this.handleDrop(quiz, e)}
                     >
                     {this.handleAnswerChoices(quiz)}
                     </div>
                     {
                        quiz.isMatched && this.state.submitted ? <p className="result correct">Correct!</p> : !quiz.isMatched && this.state.submitted ? <p className="result wrong">Wrong!</p> : ''
                     }
                  </div>
               );
               })}
            </div>
            <div className="answer-side">
               <div className="choices">
               {this.state.choices.map((choice, index) => (
                  <div
                     key={index}
                     className={`choice ${this.state.draggedWord === choice.name ? 'is-returning' : ''}`}
                     draggable="true"
                     onDragStart={(e) => this.handleDragStart(e, choice.name)}
                     onDragEnd={this.resetPosition}
                     style={this.state.draggedWord === choice.name ? answerBoxStyle : {}}
                  >
                     {choice.name}
                  </div>
               ))}
               </div>
            </div>
         </div>
         {
            Object.values(this.state.dropWords).length === this.state.quiz.length && (
               <button className="btn submit-match" onClick={this.handleSubmission}>Submit</button>
            )
         }
      </div>
   );
 }
 
 
}

export default WordMatchingGame;



// WEBPACK FOOTER //
// ./src/components/GameQuiz/WordMatchingGame.js